'use strict';

var _ = require('lodash');
var MarketAnalysisPanelService = function MarketAnalysisPanelService($filter, SearchCriteriaRule, configurationService, dowConversionService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getClassesForGivenGroup(filterData, serviceClass) {
    var classGroupMapping = configurationService.getClassGroupMapping(filterData.markets);
    return classGroupMapping[serviceClass];
  }
  function getFilterDataByBrushOrGrid(brushes, brushName, selectedGridRows, gridFieldName) {
    var data = [];
    if (selectedGridRows && selectedGridRows.length) {
      data = _.chain(selectedGridRows).map(gridFieldName).uniq().value();
    } else if (brushes && brushes[brushName]) {
      data = _.clone(brushes[brushName].filterArguments[0]);
    }
    return data;
  }
  function getMarket(brushes, selectedGridRows) {
    return getFilterDataByBrushOrGrid(brushes, 'markets', selectedGridRows, 'market');
  }
  function getPoses(brushes, selectedGridRows) {
    return getFilterDataByBrushOrGrid(brushes, 'pos', selectedGridRows, 'posName');
  }
  function getDaysOfWeek(brushes, selectedGridRows) {
    return getFilterDataByBrushOrGrid(brushes, 'dow', selectedGridRows, function (row) {
      return rmMomentFormat(row.departureDateMoment, 'DAY_OF_WEEK');
    });
  }
  function createFilterFromGridSelection(selectedGridRows) {
    return _.chain(selectedGridRows).uniqBy('departureDateMoment').transform(function (result, entry) {
      result.push({
        from: entry.departureDateMoment,
        to: entry.departureDateMoment
      });
    }).value();
  }
  function getDateRanges(brushes, selectedGridRows) {
    var dateRanges = [];
    if (selectedGridRows && selectedGridRows.length) {
      dateRanges = createFilterFromGridSelection(selectedGridRows);
    } else if (brushes.dateRange) {
      dateRanges = _.clone(brushes.dateRange.filterArguments[0]);
    }
    return dateRanges;
  }
  function getDateRangesForService(brushes, selectedGridRows, dateChartData) {
    var dateRanges = [];
    if (selectedGridRows && selectedGridRows.length) {
      dateRanges = createFilterFromGridSelection(selectedGridRows);
    } else if (brushes && brushes.dateRange) {
      if (hasSeasonFilterApplied(brushes) && dateChartData && brushes.dateRange.ranges) {
        dateRanges = createFilterFromVisibleDatChartBars(brushes.dateRange.ranges, dateChartData);
      } else {
        dateRanges = _.clone(brushes.dateRange.filterArguments[0]);
      }
    }
    return dateRanges;
  }
  function hasSeasonFilterApplied(brushes) {
    return _.get(brushes, 'seasons.filterArguments.0', false) && brushes.seasons.barCount > brushes.seasons.filterArguments[0].length;
  }
  function createFilterFromVisibleDatChartBars(ranges, data) {
    var barsWithDataInRanges = selectOnlyVisibleBarsFromBrushRanges(ranges, data);
    var rangesOfVisibleBars = createRangesFromVisibleBars(barsWithDataInRanges);
    return rangesToDateArrays(rangesOfVisibleBars, data);
  }
  function selectOnlyVisibleBarsFromBrushRanges(ranges, data) {
    var barsWithDataInRanges = [],
      dataLength = data.length;
    for (var rangeIdx = 0; rangeIdx < ranges.length; rangeIdx++) {
      var r = ranges[rangeIdx],
        fromIdx = r[0],
        toIndex = r[1] > dataLength ? dataLength : r[1];
      for (var i = fromIdx; i < toIndex; i++) {
        if (!data[i].isHidden && !data[i].isGap) {
          barsWithDataInRanges.push(i);
        }
      }
    }
    return barsWithDataInRanges;
  }
  function createRangesFromVisibleBars(barsWithDataInRanges) {
    var gluedRanges = [];
    for (var j = 0; j < barsWithDataInRanges.length; j++) {
      var range = [barsWithDataInRanges[j], barsWithDataInRanges[j] + 1];
      var k = j + 1;
      while (k < barsWithDataInRanges.length && barsWithDataInRanges[k] === range[1]) {
        range[1] = barsWithDataInRanges[k] + 1;
        k++;
        j++;
      }
      gluedRanges.push(range);
    }
    return gluedRanges;
  }
  function rangesToDateArrays(ranges, data) {
    var dataLength = data.length;
    return _.map(ranges, function (r) {
      var toIndex = r[1] > dataLength ? dataLength : r[1];
      return {
        from: data[r[0]].departureDateMoment,
        to: data[toIndex - 1].departureDateMoment
      };
    });
  }
  function getServiceClasses(brushes, selectedGridRows) {
    return getFilterDataByBrushOrGrid(brushes, 'classGroups', selectedGridRows, 'classGroup');
  }
  function getSeasons(brushes, selectedGridRows) {
    return getFilterDataByBrushOrGrid(brushes, 'seasons', selectedGridRows, 'season');
  }
  function setMarketRules(filterData) {
    return _.reduce(filterData.markets, function (result, market) {
      var marketRule = new SearchCriteriaRule({
        category: 'Location',
        criteriaName: 'Market',
        field: 'market',
        operator: '='
      });
      marketRule.leftOperand = market;
      return result.concat(marketRule);
    }, []);
  }
  function setDaysOfWeek(rules, filterData) {
    var daysOfWeek = filterData.daysOfWeek;
    if (daysOfWeek && daysOfWeek.length > 0 && daysOfWeek.length !== 7) {
      rules.push(new SearchCriteriaRule({
        category: 'Date',
        criteriaName: 'DOW',
        field: 'departureDateDOW',
        operator: '=',
        leftOperand: dowConversionService.shortIdToFullId(daysOfWeek)
      }));
    }
  }
  function buildMarketProductSearchRuleForMultipleMarkets(selectedRows) {
    var searchFilters = _.reduce(selectedRows, function (filter, row) {
      var rsqlQuery = '(market==\'' + row.market + '\';classGroups.posName==\'' + row.posName + '\';departureDateDOW==\'' + dowConversionService.shortIdToFullId([row.departureDateMomentDDD])[0] + '\';departureDate==\'' + row.departureDate + '\')';
      return filter.concat(rsqlQuery);
    }, []);
    return '(' + searchFilters.join(',') + ')';
  }
  function buildMarketProductSearchRule(filterData) {
    if (_.isArray(filterData)) {
      return buildMarketProductSearchRuleForMultipleMarkets(filterData);
    }
    var rules = setMarketRules(filterData);
    var baseDepartureDateRule = new SearchCriteriaRule({
      category: 'Time & Date',
      field: 'departureDate',
      operator: 'between'
    });
    _.forEach(filterData.dateRanges, function (range) {
      var departureDateRule = baseDepartureDateRule.clone();
      departureDateRule.leftOperand = range.from;
      departureDateRule.rightOperand = range.to;
      rules.push(departureDateRule);
    });
    if (filterData.poses && filterData.poses.length) {
      var posRule = new SearchCriteriaRule({
        category: 'Location',
        criteriaName: 'POS',
        field: 'classGroups.posName',
        operator: '='
      });
      posRule.leftOperand = filterData.poses;
      rules.push(posRule);
    }
    setDaysOfWeek(rules, filterData);
    return rules;
  }
  function buildServiceSearchRule(filterData) {
    var rules = setMarketRules(filterData);
    var baseBetweenDepartureDateRule = new SearchCriteriaRule({
      category: 'Time & Date',
      field: 'departureDate',
      operator: 'between'
    });
    _.forEach(filterData.dateRanges, function (range) {
      var departureDateRule;
      departureDateRule = baseBetweenDepartureDateRule.clone();
      //there is a problem with including last day when we perform search on service, so for now
      //quick solution format right operand to end of the day.
      departureDateRule.leftOperand = range.from.startOf('day');
      departureDateRule.rightOperand = range.to.endOf('day');
      rules.push(departureDateRule);
    });
    if (filterData.poses && filterData.poses.length) {
      var posRule = new SearchCriteriaRule({
        category: 'Location',
        field: 'serviceClassPointOfSales.significantPOS',
        operator: '='
      });
      posRule.leftOperand = [];
      _.forEach(filterData.poses, function (pos) {
        posRule.leftOperand.push(pos);
      });
      rules.push(posRule);
    }
    setDaysOfWeek(rules, filterData);
    function createClassNameRule() {
      var classNameRule = new SearchCriteriaRule({
        category: 'Product',
        field: 'serviceClassPointOfSales.className',
        operator: '='
      });
      var leftOperandData = [];
      _.forEach(filterData.serviceClasses, function (serviceClass) {
        leftOperandData.push.apply(leftOperandData, getClassesForGivenGroup(filterData, serviceClass));
      });
      classNameRule.leftOperand = _.uniq(leftOperandData);
      rules.push(classNameRule);
    }
    function createClassGroupRule() {
      var classGroupRule = new SearchCriteriaRule({
        category: 'Product',
        field: 'serviceClassPointOfSales.classGroup',
        operator: '='
      });
      classGroupRule.leftOperand = [];
      _.forEach(filterData.serviceClasses, function (group) {
        classGroupRule.leftOperand.push(group);
      });
      rules.push(classGroupRule);
    }
    if (filterData.serviceClasses && filterData.serviceClasses.length) {
      createClassNameRule();
      createClassGroupRule();
    }
    return rules;
  }
  function buildServiceShareSelectionKeysMap(selectedGridRows) {
    return _.reduce(selectedGridRows, function (keyMap, selectedRow) {
      var tempObject = {};
      tempObject[selectedRow.market + '-' + selectedRow.departureDate + '-' + selectedRow.classGroup + '-' + selectedRow.posName] = true;
      return _.extend(keyMap, tempObject);
    }, {});
  }
  return {
    getMarket: getMarket,
    getPoses: getPoses,
    getDaysOfWeek: getDaysOfWeek,
    getDateRanges: getDateRanges,
    getDateRangesForService: getDateRangesForService,
    getServiceClasses: getServiceClasses,
    buildMarketProductSearchRule: buildMarketProductSearchRule,
    buildServiceSearchRule: buildServiceSearchRule,
    getSeasons: getSeasons,
    buildServiceShareSelectionKeysMap: buildServiceShareSelectionKeysMap
  };
};
MarketAnalysisPanelService.$inject = ['$filter', 'SearchCriteriaRuleFactory', 'ConfigurationService', 'DowConversionService'];
module.exports = MarketAnalysisPanelService;